import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { OrderModel, OrderSettingsModel } from "@insite/client-framework/Types/ApiModels";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
// eslint-disable-next-line spire/fenced-imports
import CustomSmallHeadingAndText from "@WhiteCap/Components/CustomSmallHeadingAndText";
// eslint-disable-next-line spire/fenced-imports
import OrderDetailsKebabMenu from "@WhiteCap/Components/OrderDetailsKebabMenu";
import ProofOfDeliveryComponent from "@WhiteCap/Components/ProofOfDeliveryComponent";
import StatusLableAndHeading from "@WhiteCap/Components/StatusLableAndHeading";
import loadPODData from "@WhiteCap/Handlers/PODOrderHistory/PODHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";

import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    language: state.context.session.language,
    orderListData: state.WhiteCap.orderStatus.OrderData?.erpOrders,
    isLoading: state.WhiteCap.podDataStore.isLoading,
});
const mapDispatchToProps = {
    loadPODData,
};
interface OwnProps {
    order: OrderModel;
    indexNumber: number;
    orderSettings: OrderSettingsModel;
    extendedStyles?: OrderSummaryCardStyles;
}

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface OrderSummaryCardStyles {
    orderSummaryCardGridItem?: GridItemProps;
    container?: GridContainerProps;
    pageTypeLinkGridItem?: GridItemProps;
    orderNumberGridItem?: GridItemProps;
    orderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    statusGridItem?: GridItemProps;
    statusHeadingAndText?: SmallHeadingAndTextStyles;
    webOrderNumberGridItem?: GridItemProps;
    webOrderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    totalGridItem?: GridItemProps;
    totalHeadingAndText?: SmallHeadingAndTextStyles;
    orderDateHeader?: DataTableHeaderProps;
    orderNumberHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    reorderHeader?: DataTableHeaderProps;
    orderDateCells?: DataTableCellProps;
    orderNumberCells?: DataTableCellProps;
    shipToCells?: DataTableCellProps;
    statusCells?: DataTableCellProps;
    customerPOCells?: DataTableCellProps;
    orderTotalCells?: DataTableCellProps;
    reorderCells?: DataTableCellProps;
    trackButton?: ButtonPresentationProps;
}

export const orderSummaryCardStyles: OrderSummaryCardStyles = {
    orderSummaryCardGridItem: {
        width: 12,
        css: css`
            padding: 0 20px;
            max-width: 500px;
        `,
    },
    container: { gap: 5 },
    pageTypeLinkGridItem: { width: 12 },
    orderNumberGridItem: { width: 6 },
    statusGridItem: { width: 6 },
    webOrderNumberGridItem: { width: 6 },
    totalGridItem: { width: 6 },
    trackButton:{
        css:css`
        font-size: 14px !important;
        padding-left: 4px;
        padding-right: 4px;
        font-weight: 500 !important; 
        span{
            font-size: 14px !important;
            font-weight: 500 !important;
            padding-left: 4px;
            padding-right: 4px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 4px;
                        padding-right: 4px;
                        font-weight: 500 !important;

                    `,
                    css`
                        padding-left: 4px;
                        padding-right: 4px;
                        font-weight: 500 !important;

                    `,
                    css``,
                    css``,
                    css``,
                ])}
        }
        `,
    },
    orderNumberHeadingAndText: {
        heading: {
            css: css`
                color: ${WhitecapColors.iconColor};
                text-align: center;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                color: ${WhitecapColors.iconColor};
                font-size: 16px;
                text-align: center;
                font-weight: 500;
            `,
        },
    },
};

const OrderSummaryCard: FC<Props> = ({ language, order, orderSettings, isLoading, indexNumber, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(orderSummaryCardStyles, extendedStyles));
    const [PODstate, setPODState] = useState({
        isModalOpen: false,
        selectedIndex: 0,
        poNumber: "",
    });
    const isTrueOrUndefined = (value?: boolean) => value === true || value === undefined;

    const orderDateDisplay = getLocalizedDateTime({
        dateTime: order.orderDate,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;

    const loadPODDataHandler = (id: string, properties: any, arrayindex: number, po: string) => {
        setPODState({
            isModalOpen: true,
            selectedIndex: arrayindex,
            poNumber: po,
        });

        loadPODData({ orderNumber: id, id: properties.podId });
    };
    const closeModal = () => {
        setPODState({
            isModalOpen: false,
            selectedIndex: 0,
            poNumber: ''
        });
    };

    const trackHandler = (url: string | URL | undefined) => {
        if (!url) {
            return;
        }

        try {
            const parsedUrl = new URL(url, window.location.origin);

            if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
                return;
            }

            window.open(parsedUrl.toString(), "_blank", "noopener,noreferrer");
        } catch {
            return;
        }
    }

    return (
        <>
            <DataTableRow>
                <DataTableCell {...styles.orderDateCells} data-test-selector="orderHistoryTable_tableCell_date">
                    {(order.erpOrderNumber || order.webOrderNumber) && (
                        <CustomSmallHeadingAndText
                            // eslint-disable-next-line spire/avoid-dynamic-translate
                            heading={translate("ORDER #")}
                            text={order.erpOrderNumber !== "" ? order.erpOrderNumber : order.webOrderNumber}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>
                <DataTableCell {...styles.orderNumberCells} data-test-selector="orderHistoryTable_tableCell_orderNumber">
                    {" "}
                    {order.orderDate && (
                        <SmallHeadingAndText
                            heading={translate("ORDER DATE")}
                            text={order.orderDate
                                ? getLocalizedDateTime({
                                    dateTime: new Date(order.orderDate),
                                    language,
                                })
                                : ""}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>

                <DataTableCell {...styles.orderTotalCells}>
                    {order.orderGrandTotalDisplay && (
                        <SmallHeadingAndText
                            heading={translate("Total")}
                            text={order.orderGrandTotalDisplay}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>
                {/* { WCC-EC -750 - Removed Items and Delivery from Dashboard} */}

                {/* <DataTableCell {...styles.orderTotalCells}>
                    {order.properties?.orderLinesCount && (
                        <SmallHeadingAndText
                            heading={translate("Items")}
                            text={order.properties?.orderLinesCount}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell> */}
                {/* <DataTableCell {...styles.orderTotalCells}>
                        {order.properties?.shipViaDescription && (
                        <SmallHeadingAndText
                            heading={translate("DELIVERY")}
                            text={translate("{0}",`${order.properties?.isMultipleShipment?.toString() === "true" ? order.properties?.noOfShipmentPackages : order.properties?.shipViaDescription}`)}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell> */}

                {/* { WCC-EC -750 - Customer PO Added for Orser Summary} */}

               
                <DataTableCell {...styles.orderTotalCells}>
                    {order.customerPO && (
                        <SmallHeadingAndText
                            heading={translate("PO #")}
                            text={order.customerPO}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>

                 {/* { WCC-EC -750 - Added Status in My Account Dashboard} */}
                <DataTableCell {...styles.statusCells} data-test-selector="orderHistoryTable_tableCell_status">
                {order.statusDisplay && 
                    <StatusLableAndHeading
                        // isTrue={order.properties?.isMultipleShipment?.toString() === "true"}
                        heading={translate("Status")}
                        text={order.statusDisplay}
                        extendedStyles={styles.orderNumberHeadingAndText}
                />}
                </DataTableCell>

                {/* { WCC-EC -750 - Removed  POD from Dashboard} */}
                {/* <DataTableCell {...styles.shipToCells}>
                    {order.properties.hasPod.toLocaleLowerCase() === "true" && order.properties?.isMultipleShipment?.toString() !== "true" ? (
                        <Clickable
                            onClick={() => {
                                loadPODDataHandler(order.id, order.properties, indexNumber, order.customerPO);
                            }}
                        >
                            POD
                        </Clickable>
                    ) : (<>
                        {order.properties?.trackingURLs && order.properties?.isMultipleShipment?.toString() !== "true" && (<Button variant="secondary" {...styles.trackButton} onClick={() => trackHandler(order.properties?.trackingURLs)}>{translate("Track")}</Button>)}
                    </>)}
                </DataTableCell> */}
                <DataTableCell {...styles.shipToCells}>
                    <OrderDetailsKebabMenu orderNumber={order.erpOrderNumber} />
                </DataTableCell>
            </DataTableRow>
            {!isLoading ? (
                <ProofOfDeliveryComponent
                    onHandleClose={closeModal}
                    modalIsOpen={PODstate.isModalOpen}
                    poNumber={PODstate.poNumber}
                />
            ) : null}
        </>

    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaryCard);
